const regionToTagMap = {
  uk: "en-GB",
  us: "en-US",
}

exports.regionToTagMap = regionToTagMap

exports.defaultRegion = "uk"
